import { Pipe, PipeTransform } from '@angular/core';

/*
 * Returns the Customer's Address
 * Takes an object argument (Customer with Addresses).
 *
 * @Params:
 * Does not take extra parameters
 *
 * Usage:
 *   customer | ivCustomerAddressTooltipFn
 *
 * Example:
 *   {{ customer | ivCustomerAddressTooltipFn }}
 *   formats to: Customer Info + Address Info
*/

@Pipe({
  name: 'ivCustomerAddressTooltipFn'
})
export class CustomerAddressTooltipFnPipe implements PipeTransform {
  constructor() {
  }
  transform(customer: any): string {
    if (customer && customer.addresses && customer.addresses.addresses[0]) {
      const _address = customer.addresses.addresses[0];
      const _address1 = _address.address1.trim() && _address.address1 !== 'NULL' ? _address.address1 + `\n` : '';
      const _address2 = _address.address2.trim() && _address.address2 !== 'NULL' ? _address.address2 + `\n` : '';
      const _city = _address.city.trim() && _address.city !== 'NULL' ? _address.city + `\n` : '';
      const _country = _address.country.trim() && _address.country !== 'NULL' ? _address.country.trim() + '\n' : '';
      const _postal = _address.postal.trim() && _address.postal !== 'NULL' ? _address.postal + `\n` : '';
      const _region = _address.region && _address.region.trim() ? _address.region + `\n` : '';
      const _clientABN_header = _address.country && ['KOR', 'TWN', 'THA', 'PHL', 'VNM'].includes(_address.country.trim()) ? 'VAT: ' : 'ABN: ';
      const _client_abn = customer.client_abn && customer.client_abn.trim() ? _clientABN_header + customer.client_abn + '\n' : '';
      const _gstin = _address.stx_cst_rgstn && _address.stx_cst_rgstn.trim() ? 'GSTIN: ' + _address.stx_cst_rgstn : '';
      let _state = '', county = '';
      if (_address.country && ['CHN', 'JPN', 'TWN'].includes(_address.country.trim())) {
        _state = _address.state_descr.trim() && !['NULL', 'None'].includes(_address.state_descr) ? _address.state_descr + `\n` : '';
        if (_address.county) {
          county = _address.county.trim() && !['NULL', 'None'].includes(_address.county) ? _address.county + `\n` : '';
        }
        // tslint:disable-next-line:max-line-length
        return `${customer.cust_id}\n${customer.name1} ${customer.name2} ${customer.name3}\n${_address1}${_address2}${_city}${_state}${county}${_region}${_postal}${_country}${_client_abn}${_gstin}`;
      } else {
        _state = _address.state.trim() && !['NULL', 'None'].includes(_address.state) ? _address.state + `\n` : '';
        // tslint:disable-next-line:max-line-length
        return `${customer.cust_id}\n${customer.name1} ${customer.name2} ${customer.name3}\n${_address1}${_address2}${_city}${_state}${_region}${_postal}${_country}${_client_abn}${_gstin}`;
      }
    }
    return '';
  }
}
